"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var BannerWithCard = function BannerWithCard(props) {
  var _defaultProps$props$p = _extends({}, _defaultProps2.default.props, props),
      config = _defaultProps$props$p.config,
      vendorInfo = _defaultProps$props$p.vendorInfo,
      _defaultProps$props$p2 = _defaultProps$props$p.brandDetail,
      brandDetail = _defaultProps$props$p2 === undefined ? {} : _defaultProps$props$p2,
      url = _defaultProps$props$p.url,
      shop = _defaultProps$props$p.shop,
      style = _defaultProps$props$p.style,
      media = _defaultProps$props$p.media,
      content = _defaultProps$props$p.content;

  var imagePath = _baseHelper2.default.getImagePath();

  var _ref = brandDetail || {},
      _ref$socialLink = _ref.socialLink,
      socialLink = _ref$socialLink === undefined ? {} : _ref$socialLink,
      _ref$brand = _ref.brand,
      brand = _ref$brand === undefined ? {} : _ref$brand,
      _ref$brandCover = _ref.brandCover,
      brandCover = _ref$brandCover === undefined ? {} : _ref$brandCover;

  if (!vendorInfo) {
    return "No User Found";
  }
  var email = content.email || {};

  var defaultCoverImage = "https://ik.imagekit.io/marketcube/platform/storybook/mc_cover.png";
  var defaultBrandLogo = "https://ik.imagekit.io/marketcube/platform/storybook/marketcubeio.png";

  var bannerImage = !!brandCover.imageUrl ? brandCover.imageUrl : defaultCoverImage;

  var brandImage = !!brand.imageUrl ? brand.imageUrl : defaultBrandLogo;

  var description = getPropValue("text", "description", content.description, "brandDetail");

  // Claim Button
  var buttonText = getPropValue("text", "buttonText", content.buttonText, "buttonText");

  var contactInfoLabel = getPropValue("text", "contactInfoLabel", content.contactInfoLabel, "content");

  // Tabs
  var aboutTab = getPropValue("text", "aboutTab", content.aboutTab, "brandDetail");
  var contactTab = getPropValue("text", "contactTab", content.contactTab, "brandDetail");

  var tabStyle = {
    tabBodyColor: getPropValue("text", "tabBodyColor", style.tabBodyColor, "style"),
    tabBodyFontSize: getPropValue("text", "tabBodyFontSize", style.tabBodyFontSize, "style")
  };
  // Address
  var address = getPropValue("text", "address", content.address, "address");
  // const vendorEmail = getPropValue("text", "email", vendorInfo.email, "address")
  var city = getPropValue("text", "city", content.city, "address");
  var provinceCode = getPropValue("text", "provinceCode", content.provinceCode, "address");
  var country = getPropValue("text", "country", content.country, "address");

  var firstName = getPropValue("text", "firstName", content.firstName, "address");
  var lastName = getPropValue("text", "lastName", content.lastName, "address");
  var phoneNumber = getPropValue("text", "phoneNumber", content.phoneNumber, "address");
  var pinCode = getPropValue("text", "pinCode", content.pinCode, "address");

  // Brand Title
  var brandTitleText = getPropValue("text", "vendorInfo", content.brandName, "content");
  var brandTitle = {
    titleColor: getPropValue("text", "titleColor", style.titleColor, "style"),
    titleFontSize: getPropValue("text", "titleFontSize", style.titleFontSize, "style")
  };

  // Main card
  var bannerCard = {
    radius: getPropValue("text", "radius", style.radius, "style")
  };

  // Brand logo style
  var brandLogo = {
    logoMaxWidth: getPropValue("text", "logoMaxWidth", style.logoMaxWidth, "style"),
    logoMaxHeight: getPropValue("text", "logoMaxHeight", style.logoMaxHeight, "style")
  };
  return _react2.default.createElement(
    _styled.MainWrapper,
    null,
    _react2.default.createElement(
      _styled.PosterImage,
      null,
      _react2.default.createElement(_reactBootstrap.Image, { src: bannerImage, alt: brandTitleText })
    ),
    _react2.default.createElement(
      _styled.BannerCard,
      _extends({}, bannerCard, { className: "container p-0" }),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 8, className: "p-4 order-2 order-md-1" },
        _react2.default.createElement(
          _styled.TabHeader,
          { className: "d-flex flex-wrap flex-column flex-md-row" },
          _react2.default.createElement(
            "div",
            { className: "brand-name mb-2 mb-lg-4 order-2 order-md-1" },
            _react2.default.createElement(
              _styled.BrandTitle,
              _extends({}, brandTitle, { className: "mr-2 text-capitalize" }),
              brandTitleText
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "claim-btn ml-md-auto text-md-right order-1 order-md-2" },
            !(email || vendorInfo.isInactive) && _react2.default.createElement(
              _reactBootstrap.Button,
              {
                href: (url || config.clientURL) + "/claim/" + shop + "/" + vendorInfo._id,
                type: "button",
                className: "btn btn-warning"
              },
              buttonText
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Tabs,
          {
            defaultActiveKey: "about",
            transition: false,
            id: "noanim-tab-example",
            className: "brand-info border-0"
          },
          _react2.default.createElement(
            _reactBootstrap.Tab,
            { eventKey: "about", title: aboutTab, className: "border-0" },
            _react2.default.createElement(
              _styled.TabBody,
              tabStyle,
              _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: description } })
            )
          ),
          !content.isHideVendorContact && _react2.default.createElement(
            _reactBootstrap.Tab,
            { eventKey: "contact", title: contactTab },
            _react2.default.createElement(
              _styled.TabBody,
              _extends({}, tabStyle, { className: "address mb-0 text-left" }),
              _react2.default.createElement(
                "span",
                null,
                " " + firstName + " " + lastName + " "
              ),
              _react2.default.createElement("br", null),
              email && _react2.default.createElement(
                "a",
                { href: "mailto:" + email },
                email
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "span",
                null,
                phoneNumber
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "span",
                null,
                address
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "span",
                null,
                " ",
                city + ", " + (provinceCode ? provinceCode + "," : "") + " " + country
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { className: "about-des pl-0" },
          _react2.default.createElement(
            "div",
            { className: "social-info" },
            _react2.default.createElement(_reactBootstrap.ListGroup, { horizontal: true, className: "info" }),
            socialLink && _react2.default.createElement(
              _reactBootstrap.ListGroup,
              { horizontal: true, className: "social" },
              socialLink.facebook && _react2.default.createElement(
                _reactBootstrap.ListGroup.Item,
                {
                  action: true,
                  active: false,
                  className: "social-icons",
                  href: socialLink.facebook,
                  target: "_blank"
                },
                "facebook"
              ),
              socialLink.linkedin && _react2.default.createElement(_reactBootstrap.ListGroup.Item, {
                action: true,
                className: "social-icons linkedin",
                href: socialLink.linkedin,
                target: "_blank"
              }),
              socialLink.instagram && _react2.default.createElement(
                _reactBootstrap.ListGroup.Item,
                {
                  action: true,
                  className: "social-icons instagram",
                  href: socialLink.instagram,
                  target: "_blank"
                },
                "instagram"
              ),
              socialLink.youtube && _react2.default.createElement(
                _reactBootstrap.ListGroup.Item,
                {
                  action: true,
                  className: "social-icons youtube",
                  href: socialLink.youtube,
                  target: "_blank"
                },
                "youtube"
              ),
              socialLink.twitter && _react2.default.createElement(
                _reactBootstrap.ListGroup.Item,
                {
                  action: true,
                  className: "social-icons twitter",
                  href: socialLink.twitter,
                  target: "_blank"
                },
                "twitter"
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _styled.ContactInfo,
        { className: "col-md-4 logo-desc p-4 order-1 order-md-2 text-md-right" },
        _react2.default.createElement(_styled.BrandLogo, _extends({}, brandLogo, { src: brandImage, alt: "logo" }))
      )
    )
  );
};

exports.default = BannerWithCard;